import WRAP from "WRAP-JS";

/* eslint-disable */
//WRAP.Geo.Viewを継承してwaitLayerDrawとupdateLayerStatusをオーバーライド
class ViewExt extends WRAP.Geo.View {
  wait_layer_checker = [];

  constructor(id) {
    super(id);
  }

  waitLayerDraw = function(func, duration, timeout, layers, ignoreError) {
    var cs = (new Date()).getTime() / 1000;
    var check = {
      wait_layer_func: func,
      wait_layer_start: cs + duration,
      wait_layer_end: cs + timeout,
      wait_layers: layers,
      ignore_error :ignoreError
    }
    this.wait_layer_checker.push(check);
  }

  updateLayerStatus = function() {
    for ( var i = 0 ; i < this.layers.length ; i++ ) {
      var layer = this.layers[i];
      if ( layer.visible() ) {
        var image_wait = false;
        var image_error = false;
        var image_count = 0;
        if ( layer._revision.dl >= layer._revision.status ) {
          for ( var k = 0 ; k < layer._dl.length ; k++ ) {
            var feature = layer._dl[k];
            var image = feature.image;
            if ( image ) {
              image_count++;
              if ( WRAP.Geo.Cache.imageError[image] )
                image_error = true;
              else if ( !WRAP.Geo.Cache.imageCache[image] || !WRAP.Geo.Cache.imageCache[image].loaded )
                image_wait = true;
            }
          }
        }
        if ( !layer._render_status )
          layer._render_status = {status:"valid"};
        if ( layer._error_text )
          layer._render_status = {status:"error", reason:layer._error_text};
        else if ( image_error )
          layer._render_status = {status:"error", reason:"image load error."};
        else if ( layer._render_status.status != 'error' ) {
          if ( image_wait )
            layer._render_status = {status:"invalid", reason:"image load waiting."};
          else if ( image_count )
            layer._render_status = {status:"valid"};
        }
        if ( !image_wait )
          layer._revision.status++;
      }
    }

    if (this.wait_layer_checker.length !== 0) {
      var draw_end_time = (new Date).getTime();
      var currentTime = draw_end_time/1000;

      for ( var idx = 0 ; idx < this.wait_layer_checker.length ; idx++ ) {
        var checker = this.wait_layer_checker[idx];
        if (currentTime >= checker.wait_layer_start) {
          var status = {completed: [], incompleted: [], error: []};
          const _layers = checker.wait_layers || this.layers;
          for (var i = 0; i < _layers.length; i++) {
            var layer = _layers[i];
            // layerがvisible()==trueでも layer設定がminZoom〜maxZoomの範囲外であれば表示状態と判定しない拡張機能
            let minZoom = this.min_zoom;
            if (layer._conf && layer._conf.Attributes && layer._conf.Attributes.min_zoom) {
              minZoom = layer._conf.Attributes.min_zoom;
            }
            let maxZoom = this.max_zoom;
            if (layer._conf && layer._conf.Attributes && layer._conf.Attributes.max_zoom) {
              maxZoom = layer._conf.Attributes.max_zoom;
            }
            var isVisible = layer.visible() && minZoom <= this.zoom && this.zoom <= maxZoom;
            if (isVisible) {
            // if (layer.visible()) {
              var loading = layer._data && layer._data.loading && layer._data.loading();
              var ls = layer._render_status.status;
              if (ls == "valid" && !loading) {
                status.completed.push(layer);
              } else if (ls == "error")
                status.error.push(layer);
              else
                status.incompleted.push(layer);
              if (layer._silent) {
                if (ls == "valid" || ls == "error") {
                  layer._silent = undefined;
                  layer._silent_content = true;
                }
              }
            }
          }
          var to = currentTime - checker.wait_layer_end;
          // errorがあってもignore_errorが指定されていればコールバックする拡張機能を実装
          var hasError = !!status.error.length && !checker.ignore_error;
          //console.log("wait draw timeleft="+to
          //            +" completed="+status.completed.length
          //            +" imcompleted="+status.incompleted.length
          //            +" error="+status.error.length);
          if ((!status.incompleted.length && !hasError) || to >= 0) {
            status.elapsed = currentTime - checker.wait_layer_start
            // var func = this._wait_layer_func;
            // this._wait_layer_func = null;
            // this._wait_layer_start = this._wait_layer_end = 0;
            // if (func)
            //   func(status);
            if (checker.wait_layer_func){
              checker.wait_layer_func(status)
            }
            this.wait_layer_checker.splice(idx--, 1);
          }
        }
      }
    }
    //checkLayerStatusは使用しないので以降はomit
  }
}
/* eslint-disable */
export default ViewExt;
